export const calcAr_schema = (value, minAmount = 0, maxAmount, page) => {
  if (maxAmount == null || maxAmount === 0) {
    return { valid: true, message: "" };
  }
  if (page === "manasik") {
    if (value >= minAmount && value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: `من فضلك أدخل قيمة بين ${minAmount} و ${maxAmount}`,
      };
    }
  } else {
    if (value <= maxAmount) {
      return { valid: true, message: "" };
    } else {
      return {
        valid: false,
        message: ` من فضلك أدخل قيمة أكبر من او تساوي ${maxAmount}`,
      };
    }
  }
};
